import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    navigation: [
      { label: '首页', to: '/' },
      { label: '漫画分类', to: '/category/all' },
      { label: '关于我们', to: '/about' },
    ],
    articles: [
      { label: '新手指南', to: '/article/article-1' },
      { label: '隐藏功能', to: '/article/article-2' },
      { label: '漫画推荐', to: '/article/article-3' },
      { label: '常见问题', to: '/article/article-4' },
    ],
    about: [
      { label: '品牌介绍', to: '/about' },
      { label: '联系方式', to: '/about#contact' },
    ],
  };

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-bold tracking-tight text-foreground-950 font-[var(--font-heading)]">
                JM<span className="text-primary-500">Comic</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              JMComic 是深受用户喜爱的漫画阅读平台，提供海量优质漫画资源，流畅的阅读体验，让你随时随地畅享漫画世界。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">网站导航</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.navigation.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">实用文章</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.articles.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">关于</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.about.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-sm" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-sm" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors" aria-label="邮箱" rel="nofollow">
                <i className="ri-mail-line text-sm" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} JMComic. 保留所有权利。
          </p>
          <p className="text-xs text-foreground-500">
            本站为 JMComic 官方导航与使用指南 | 提供最新访问入口与使用教程
          </p>
        </div>
      </div>
    </footer>
  );
}